import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'userCategory',
    serviceName: 'unitadmin',
    query: gql`
      query userCategory(
        $ids: [String]
        $title: String
        $lab_ids: [String]
        $unit_ids: [String]
        $category_id: String
        $walk_direction: String # UP , DOWN
        $depth: Int
        $type: String # CLUBE , CUSTOMER
        $is_default: Int # 0 , 1
        $page: Int
        $limit: Int
        $orderBy_field: String
        $orderBy_direction: String # ASC , DESC
      ) {
        userCategory(
          ids: $ids
          title: $title
          lab_ids: $lab_ids
          unit_ids: $unit_ids
          category_id: $category_id
          walk_direction: $walk_direction
          depth: $depth
          type: $type
          is_default: $is_default
          page: $page
          limit: $limit
          orderBy_field: $orderBy_field
          orderBy_direction: $orderBy_direction
        ) {
          total
          last_page
          data {
            id
            title
            parent {
              id
            }
            #media {
            #  full_url
            #}
            children {
              id
              title
              parent {
                title
              }
              #media {
              #  full_url
              #}
              children {
                id
              }
            }
          }
        }
      }
    `,
  },
  delete: {
    name: 'deleteUserCategory',
    serviceName: 'unitadmin',
    query: gql`
      mutation deleteUserCategory($ids: [String]!) {
        deleteUserCategory(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
  current: {
    name: 'userCategory',
    serviceName: 'unitadmin',
    query: gql`
      query userCategory($ids: [String]) {
        userCategory(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
  assignment: {
    name: 'userCategory',
    serviceName: 'unitadmin',
    query: gql`
      query userCategory($ids: [String]) {
        userCategory(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
